import { useLocation } from 'react-router-dom';
import { useQueryParams } from 'hooks/routes/useQueryParams';
import { useNavigate } from 'hooks/routes';
import { Parameters } from 'constants/queryParameters';
import {
  AssetsIcon_24,
  DocumentIcon_24,
  GeneralInfoIcon_24,
  TransactionsIcon_24,
} from 'assets/icons';
import { NavTabItem, NavTabsContainer } from 'components/NavTabs';

import messages from './IndependentIraNavTabs.messages';

const IndependentIraNavTabs = (): JSX.Element => {
  const { pathname } = useLocation();
  const independentIraUserId = useQueryParams(Parameters.independentIraUserId) ?? '';
  const contributionId = useQueryParams(Parameters.contributionId);

  const {
    toIndependentIraInfo,
    toIndependentIraTransactions,
    toIndependentIraOpenOrders,
    toIndependentIraAssets,
    toContributionIndependentIRAAccountDetail,
    toContributionIndependentIRAAccountDetailTransactions,
    toContributionIndependentIRAAccountDetailOpenOrders,
    toContributionIndependentIRAAccountDetailAssets,
  } = useNavigate();

  const onGeneralInfoClick = (): void => {
    if (contributionId) {
      toContributionIndependentIRAAccountDetail(contributionId, independentIraUserId, {
        replace: true,
      });
    } else {
      toIndependentIraInfo(independentIraUserId, { replace: true });
    }
  };

  const onTransactionsClick = (): void => {
    if (contributionId) {
      toContributionIndependentIRAAccountDetailTransactions(
        contributionId,
        independentIraUserId,
        {
          replace: true,
        },
      );
    } else {
      toIndependentIraTransactions(independentIraUserId, { replace: true });
    }
  };

  const onOpenOrdersClick = (): void => {
    if (contributionId) {
      toContributionIndependentIRAAccountDetailOpenOrders(
        contributionId,
        independentIraUserId,
        {
          replace: true,
        },
      );
    } else {
      toIndependentIraOpenOrders(independentIraUserId, { replace: true });
    }
  };

  const onAssetsClick = (): void => {
    if (contributionId) {
      toContributionIndependentIRAAccountDetailAssets(
        contributionId,
        independentIraUserId,
        {
          replace: true,
        },
      );
    } else {
      toIndependentIraAssets(independentIraUserId, { replace: true });
    }
  };

  return (
    <NavTabsContainer>
      <NavTabItem
        onClick={onGeneralInfoClick}
        isActive={pathname.includes('general-info')}
      >
        <GeneralInfoIcon_24 />
        {messages.generalInfo}
      </NavTabItem>

      <NavTabItem
        onClick={onTransactionsClick}
        isActive={pathname.includes('transactions')}
      >
        <TransactionsIcon_24 />
        {messages.transactions}
      </NavTabItem>

      <NavTabItem onClick={onOpenOrdersClick} isActive={pathname.includes('open-orders')}>
        <DocumentIcon_24 />
        {messages.openOrders}
      </NavTabItem>

      <NavTabItem onClick={onAssetsClick} isActive={pathname.includes('assets')}>
        <AssetsIcon_24 />
        {messages.assets}
      </NavTabItem>
    </NavTabsContainer>
  );
};

export default IndependentIraNavTabs;
